import {
  type EntityId,
  type PermissionCheckInput,
  type PermissionCheckMatch,
  type PermissionCheckSuccess,
  type PermissionType,
  type SingleOrOptionalEntityIds,
} from '@terros/common'
import { useTantalimQuery } from '../query'
import { permissionCheckKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { toValidPermissionIds } from './util'

export const TARGET_MISSING: EntityId = `U:TARGET_MISSING`

export function usePermissionCheck({
  permissionType,
  targetId = TARGET_MISSING,
  match = 'any',
  enabled = true,
}: {
  permissionType: PermissionType
  targetId: SingleOrOptionalEntityIds | undefined
  match?: PermissionCheckMatch
  enabled?: boolean
}): GetHookResponse<boolean> {
  const target = toValidPermissionIds(targetId) ?? TARGET_MISSING
  return useTantalimQuery<PermissionCheckInput, PermissionCheckSuccess, boolean>({
    url: '/permission/check',
    queryKey: permissionCheckKey({ permissionType, targetId, match }),
    input: {
      permissionType,
      targetId: target,
      match,
    },

    convertResponse: (data) => data.hasPermission,
    options: {
      enabled: enabled && target !== TARGET_MISSING,
    },
  })
}
